import React from 'react'
import { createMuiTheme } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#03B0EE',
      contrastText: '#FFF',
    },
  },
  typography: { useNextVariants: true },
})

export default props => {
  const {
    label,
    options,
    value = '',
    onChange,
    id,
  } = props

  return (
    <ThemeProvider theme={theme}>
      <FormControl style={{ width: '100%' }}>
        <InputLabel htmlFor={id}>
          {label}
        </InputLabel>
        <Select
          value={value}
          onChange={event => {
            if (!onChange) return
            
            const aux = event.target.value
            const option = options.find(option => option.value === aux)
            onChange(event, option)
          }}
          inputProps={{
            name: label,
            id,
          }}
        >
          {options.map((option, index) => (
            <MenuItem
              value={option.value}
              key={String(index)}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </ThemeProvider>
  )
}
